import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
// import { getAnalytics } from "firebase/analytics"; // Analytics optional

const firebaseConfig = {
    apiKey: "AIzaSyAdPtn9H-kErj8jouzTqooC6gxY55EkkI8",
    authDomain: "hi-himanshu.firebaseapp.com",
    projectId: "hi-himanshu",
    storageBucket: "hi-himanshu.firebasestorage.app",
    messagingSenderId: "1034915723523",
    appId: "1:1034915723523:web:98aa17a40cf9302113d136",
    measurementId: "G-Y52E3WNFSQ"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
// const analytics = getAnalytics(app);

export { db };
export default app;
